import api from 'services/technical-visit/technical-visit'

export const handleSave = async (technicalVisitId: string, partId: string, quantity: number) => {
  let res = await api.removePart(technicalVisitId, partId, quantity)

  return res?.data?.success
}
